package com.milta.core.localization

data class HomeStrings(
    val navTournee: String,
    val navEcoDriving: String,
    val navCommunity: String,
    val navRewards: String,
    val navHome: String,
    val navRoutes: String,
    val navTeam: String,
    val navProfile: String,
)
